import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import NotShittyUploadcareWidget from "./NotShittyUploadcareWidget";
import { useUpdateMembershipTierImageMutation, useMembershipTierImageQuery, } from '../types';
export const PrimaryAction = "Membership Tiers";
const MembershipLevelImageUpload = ({ tier }) => {
    var _a;
    const { data, loading, error } = useMembershipTierImageQuery({
        variables: {
            tierId: tier.id,
        },
    });
    const [updateMembershipTierImage] = useUpdateMembershipTierImageMutation();
    const image = (_a = data === null || data === void 0 ? void 0 : data.membershipTier) === null || _a === void 0 ? void 0 : _a.image;
    const handleUpload = async (currentFile) => {
        // mixpanel.track(PrimaryAction, {
        //   action: MembershipLevelAction.UpdatedMembershipImage,
        // })
        if (!(currentFile === null || currentFile === void 0 ? void 0 : currentFile.originalImageInfo)) {
            return;
        }
        const params = {
            name: currentFile === null || currentFile === void 0 ? void 0 : currentFile.name,
            mimeType: currentFile === null || currentFile === void 0 ? void 0 : currentFile.mimeType,
            path: currentFile === null || currentFile === void 0 ? void 0 : currentFile.cdnUrl,
        };
        await updateMembershipTierImage({
            variables: {
                membershipTierId: tier.id,
                imageInput: params
            },
            refetchQueries: ["MembershipTierImage"],
            awaitRefetchQueries: true,
        });
    };
    const bgStyle = {
        backgroundImage: `url(${image === null || image === void 0 ? void 0 : image.cdnPath})`,
        backgroundSize: "contain",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        paddingBottom: "100%",
    };
    return (_jsx(_Fragment, { children: _jsx("div", { className: "relative aspect-square mb-4 bg-wfGray-700", style: bgStyle, children: _jsx("div", { className: "absolute right-07 bottom-07", children: _jsx("div", { className: "relative active:-left-2 active:-bottom-2 bg-white border cursor-pointer border-wfGray-600 hover:border-wfGray-800 px-3.5 py-1.5", children: !!data ? _jsx(NotShittyUploadcareWidget, { image: image, onChangeCallback: handleUpload, crop: "1280x1280" }) : _jsx("div", { children: "Loading..." }) }) }) }) }));
};
export default MembershipLevelImageUpload;
